export default __webpack_public_path__ + "static/media/ic_buscar_una_ficha.e10322b1.svg";